import React, { Suspense, ReactNode, useContext } from 'react';
import { Loader } from '../components/ui/Loader';
import ErrorBoundary from '../components/ErrorBoundary';
import { RouteLoadingContext } from './router/routeLoadingContext';

interface LazyLoaderProps {
  children: ReactNode;
  withErrorBoundary?: boolean;
}

/**
 * LazyLoader - A component for handling lazy-loaded components with a consistent loading state
 * and optional error boundary
 */
const LazyLoader: React.FC<LazyLoaderProps> = ({ children, withErrorBoundary = true }) => {
  // A new per-route Suspense boundary commits its fallback even during a
  // transition. Let the persistent shell boundary own route loading instead.
  const shellOwnsLoading = useContext(RouteLoadingContext);
  const content = shellOwnsLoading ? children : (
    <Suspense fallback={<div className="card-padding-lg flex items-center justify-center"><Loader /></div>}>
      {children}
    </Suspense>
  );

  if (withErrorBoundary) {
    return <ErrorBoundary>{content}</ErrorBoundary>;
  }
  
  return content;
};

export default LazyLoader;
